import { createFileRoute } from '@tanstack/react-router'
import { IcanAssessmentsPage } from '@/features/ndis-standards/ican'
import { requireActiveSubscription } from '@/lib/middleware'

export const Route = createFileRoute('/_authenticated/_organization/ndis-standards/ican')({
  beforeLoad: async () => requireActiveSubscription(),
  component: IcanAssessmentsPage,
})
